import React from 'react';
import { Helmet } from 'react-helmet-async';
import NavBar from '@/components/NavBar';
import Footer from '@/components/Footer';
import { MyDownloadsContent } from '@/components/user/MyDownloadsContent';

const MyDownloads = () => {
  return (
    <>
      <Helmet>
        <title>My Downloads - LightsHunt</title>
        <meta name="description" content="View and manage your downloaded light sequences. Re-download sequences and add them to your display list." />
      </Helmet>
      
      <div className="min-h-screen bg-background">
        <NavBar />
        <main className="pt-20">
          <MyDownloadsContent />
        </main>
        <Footer />
      </div>
    </>
  );
};

export default MyDownloads;